import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { Text } from "@react-three/drei";

function Building({ position, size, color, label }) {
  const edgesGeo = useMemo(() => new THREE.EdgesGeometry(new THREE.BoxGeometry(...size)), [size]);
  return (
    <group position={position}>
      <mesh position={[0, size[1] / 2, 0]}>
        <boxGeometry args={size} />
        <meshStandardMaterial color="#060608" roughness={0.85} metalness={0.2} />
      </mesh>
      <lineSegments position={[0, size[1] / 2, 0]} geometry={edgesGeo}>
        <lineBasicMaterial color={color} toneMapped={false} />
      </lineSegments>
      {label && (
        <Text
          position={[0, size[1] + 1.4, size[2] / 2 + 0.05]}
          fontSize={1.1}
          color={color}
          anchorX="center"
          anchorY="middle"
          font={undefined}
          letterSpacing={0.05}
        >
          {label}
        </Text>
      )}
    </group>
  );
}

function HoloPanel({ position, rotation = [0, 0, 0], size = [4, 2.4], color = "#01FFFF" }) {
  return (
    <group position={position} rotation={rotation}>
      <mesh>
        <planeGeometry args={size} />
        <meshBasicMaterial color={color} transparent opacity={0.06} side={THREE.DoubleSide} />
      </mesh>
      <lineSegments>
        <edgesGeometry args={[new THREE.PlaneGeometry(...size)]} />
        <lineBasicMaterial color={color} toneMapped={false} />
      </lineSegments>
    </group>
  );
}

export default function City({ buildings }) {
  const groundRef = useRef();
  useFrame(({ clock }) => {
    if (groundRef.current) {
      groundRef.current.material.emissiveIntensity = 0.15 + Math.sin(clock.elapsedTime * 0.6) * 0.05;
    }
  });

  return (
    <group>
      <mesh ref={groundRef} rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.05, -60]}>
        <planeGeometry args={[80, 260]} />
        <meshStandardMaterial
          color="#040406"
          emissive="#0a1a1f"
          emissiveIntensity={0.15}
          roughness={0.9}
        />
      </mesh>

      {buildings.map(({ key, ...b }) => (
        <Building key={key} {...b} />
      ))}

      <HoloPanel position={[-6, 5.5, 6]} rotation={[0, 0.5, 0]} color="#01FFFF" />
      <HoloPanel position={[6.5, 9, -10]} rotation={[0, -0.4, 0]} color="#FF007F" size={[5, 3]} />
      <HoloPanel position={[9.5, 3.2, -74]} rotation={[0, -0.6, 0]} color="#01FFFF" size={[3, 2]} />
    </group>
  );
}
